import { trackError } from 'helpers/track_error';
import type { SurveyQuestionsKeys } from 'packages/signup/components/SurveyQuestions';

export default function trackQuestionViewedEvent(
  questionKey: SurveyQuestionsKeys,
  surveySource?: string
) {
  try {
    GustoAnalytics.track({
      eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
      eventName: 'SurveySignupModalSurveyQuestionViewed',
      data: {
        questionKey,
        survey_source: surveySource,
      },
    });
  } catch (e) {
    trackError({
      error: new Error(`Error tracking SurveySignupModalSurveyQuestionViewed for ${questionKey}`),
    });
  }
}
